import { render, staticRenderFns } from "./BankList.vue?vue&type=template&id=16c3264e&"
import script from "./BankList.vue?vue&type=script&lang=js&"
export * from "./BankList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports